import { Component, OnInit } from '@angular/core';
import { TypeDocumentProduitCrm } from '../../core/model/produitCrm/type-document-produitCrm';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddTypeDocumentProduitCrmComponent } from './add-type-document-produit-crm/add-type-document-produit-crm.component';
import { ProduitCrmService } from '../../core/service/produit-crm.service';

@Component({
  selector: "app-type-document-produit-crm",
  templateUrl: "./type-document-produit-crm.component.html",
  styleUrls: ["./type-document-produit-crm.component.scss"]
})
export class TypeDocumentProduitCrmComponent implements OnInit {
  typeDocumentProduitCrm: TypeDocumentProduitCrm[];

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _produitCrmService: ProduitCrmService
  ) {}

  ngOnInit() {
    this.getTypeDocumentProduitCrm();
  }

  getTypeDocumentProduitCrm() {
    this._produitCrmService.getTypeDocumentProduitCrm().subscribe(data => {
      this.typeDocumentProduitCrm = data;
    });
  }

  deleteDetail(group: TypeDocumentProduitCrm) {}

  editDetail(typeDocumentProduitCrm: TypeDocumentProduitCrm) {
    const modalRef = this.modalService.open(
      AddTypeDocumentProduitCrmComponent,
      {
        centered: true,
        backdropClass: "light-blue-backdrop",
        backdrop: "static",
        windowClass: "my-app-app-modal-class"
      }
    );

    modalRef.componentInstance.typeDocumentProduitCrm = typeDocumentProduitCrm;
    modalRef.result.then(
      result => {
        console.log("result", result);
        // on close
        this.getTypeDocumentProduitCrm();
      },
      reason => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  addTyeDocumentProduitCrm() {
    const modalRef = this.modalService.open(
      AddTypeDocumentProduitCrmComponent,
      {
        centered: true,
        backdropClass: "light-blue-backdrop",
        backdrop: "static",
        windowClass: "type-document-garantie-modal"
      }
    );
    //modalRef.componentInstance.profile = this.profile;
    modalRef.result.then(
      result => {
        console.log("result", result);
        // on close
        this.getTypeDocumentProduitCrm();
      },
      reason => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }
}
